// eslint-disable-next-line no-restricted-imports
import { message } from 'antd';
import { AttachmentsAPI } from 'api/attachments';
/**
 * This is an extension to Ant's existing utils.
 * We would need a util that can return the file type
 * based on the url instead of a `UploadFile` type.
 */ export const extname = (filePath)=>{
    var __split, __split1, _, _this;
    const temp = filePath === null || filePath === void 0 ? void 0 : filePath.split('/');
    const filename = temp === null || temp === void 0 ? void 0 : temp[(temp === null || temp === void 0 ? void 0 : temp.length) - 1];
    const filenameWithoutSuffix = filename === null || filename === void 0 ? void 0 : filename.split(/#|\?/)[0];
    return (_this = /\.[^./\\]*$/.exec(filenameWithoutSuffix) || [
        ''
    ]) === null || _this === void 0 ? void 0 : (_ = _this[0]) === null || _ === void 0 ? void 0 : (__split1 = _.split) === null || __split1 === void 0 ? void 0 : (__split = __split1.call(_, '.')) === null || __split === void 0 ? void 0 : __split[1];
};
export const isImageUrlFromExtension = (filePath)=>{
    const extension = extname(filePath);
    if (/^data:image\//.test(filePath) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico)$/i.test(extension)) {
        return true;
    }
    return false;
};
export const isVideoUrlFromExtension = (filePath)=>{
    const extension = extname(filePath);
    if (/^(mp4|mov|avi|wmv|flv|webm)$/i.test(extension)) {
        return true;
    }
    return false;
};
export const isPdfUrlFromExtension = (filePath)=>{
    const extension = extname(filePath);
    if (/^(pdf)$/i.test(extension)) {
        return true;
    }
    return false;
};
export const isDocUrlFromExtension = (filePath)=>{
    const extension = extname(filePath);
    if (/^(doc|docx)$/i.test(extension)) {
        return true;
    }
    return false;
};
export const isSheetUrlFromExtension = (filePath)=>{
    const extension = extname(filePath);
    if (/^(xls|xlsx|csv)$/i.test(extension)) {
        return true;
    }
    return false;
};
const EXTENSION_MIME_MAP = {
    mpp: 'application/vnd.ms-project',
    mpt: 'application/vnd.ms-project',
    csv: 'text/csv',
    pdf: 'application/pdf',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    json: 'application/json',
    xml: 'application/xml',
    txt: 'text/plain'
};
export const getFileContentType = (file)=>{
    var _ref, _EXTENSION_MIME_MAP_ext;
    var _file_name_split_pop;
    if (file.type) {
        return file.type;
    }
    const ext = (_ref = (_file_name_split_pop = file.name.split('.').pop()) === null || _file_name_split_pop === void 0 ? void 0 : _file_name_split_pop.toLowerCase()) !== null && _ref !== void 0 ? _ref : '';
    return (_EXTENSION_MIME_MAP_ext = EXTENSION_MIME_MAP[ext]) !== null && _EXTENSION_MIME_MAP_ext !== void 0 ? _EXTENSION_MIME_MAP_ext : 'application/octet-stream';
};
export const formatBytes = (bytes, decimals = 2)=>{
    if (bytes === 0) {
        return '0 Bytes';
    }
    const kbValue = 1024;
    const decimalPoints = decimals < 0 ? 0 : decimals;
    const sizes = [
        'Bytes',
        'KB',
        'MB',
        'GB'
    ];
    const convBase = Math.floor(Math.log(bytes) / Math.log(kbValue));
    return `${parseFloat((bytes / kbValue ** convBase).toFixed(decimalPoints))} ${sizes[convBase]}`;
};
export const openFileUrl = (e, _id, downloadAttachmentErrorText)=>{
    e.preventDefault();
    e.stopPropagation();
    if (!_id) {
        return;
    }
    AttachmentsAPI.getAttachment(_id).then((attachment)=>{
        const $a = document.createElement('a');
        const downloadUrl = attachment.downloadUrl || attachment.location || '';
        $a.href = downloadUrl;
        $a.download = downloadUrl;
        $a.target = '_blank';
        document.body.appendChild($a);
        $a.click();
        document.body.removeChild($a);
    }, ()=>{
        message.error(downloadAttachmentErrorText);
    });
};
